module.exports = __webpack_public_path__ + "img/blue_021.035680eb.png";